export default "__VITE_ASSET__dlnzGZQm__"